module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 102
// module chunks = 14